// will be called when js initialization...
function initWidgetSettings (params) {
    this.getStoreData(params);
}

export default initWidgetSettings;
